// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Table from "./Table.res.js";
import * as React from "react";
import * as Spinner from "../feedback-indicators/Spinner.res.js";
import * as DropZone from "../selection-and-input/DropZone.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as SearchBar from "../selection-and-input/SearchBar.res.js";
import * as Placeholder from "../layout-and-structure/Placeholder.res.js";
import * as SliderTrack from "../layout-and-structure/SliderTrack.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PredictiveLoadingBar from "../feedback-indicators/PredictiveLoadingBar.res.js";

function TableView$TableFilterBar(props) {
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(SliderTrack.make, {
      children: props.filters,
      compact: true,
      gap: "small",
      layout: "Adaptative"
    }),
    spaceX: "large",
    spaceBottom: "xmedium"
  });
}

let make = React.memo(props => {
  let children = props.children;
  if (props.displayed) {
    return JsxRuntime.jsx(Box.make, {
      children: children,
      spaceTop: "xmedium",
      grow: true,
      style: {
        backgroundColor: "#fefefe",
        borderRadius: "6px"
      }
    });
  } else {
    return children;
  }
});

let style = {
  display: "flex",
  padding: "20px",
  justifyContent: "center"
};

function TableView$LoadMoreSpinner(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Spinner.make, {
      size: 24,
      color: "#a2a1b0"
    }),
    style: style
  });
}

function TableView(props) {
  let loadingBarEstimatedDuration = props.loadingBarEstimatedDuration;
  let onErrorDrop = props.onErrorDrop;
  let onSuccessDrop = props.onSuccessDrop;
  let onLoadMoreProp = props.onLoadMore;
  let onSearchQueryChange = props.onSearchQueryChange;
  let __filters = props.filters;
  let __searchPlaceholder = props.searchPlaceholder;
  let searchBar = props.searchBar;
  let __compactPlaceholder = props.compactPlaceholder;
  let __hideReloadingPlaceholder = props.hideReloadingPlaceholder;
  let __hideCard = props.hideCard;
  let data = props.data;
  let hideCard = __hideCard !== undefined ? __hideCard : false;
  let hideReloadingPlaceholder = __hideReloadingPlaceholder !== undefined ? __hideReloadingPlaceholder : false;
  let compactPlaceholder = __compactPlaceholder !== undefined ? __compactPlaceholder : false;
  let searchPlaceholder = __searchPlaceholder !== undefined ? __searchPlaceholder : I18n.t("Search");
  let filters = __filters !== undefined ? __filters : [];
  let placeholderEmptyState = Stdlib_Option.getOr(props.placeholderEmptyState, JsxRuntime.jsx(Placeholder.make, {
    status: "NoDataAvailable",
    compact: compactPlaceholder
  }));
  let onLoadMore = AsyncData.isIdle(data) ? onLoadMoreProp : undefined;
  let footerComponent;
  let exit = 0;
  if (typeof data !== "object") {
    footerComponent = data === "NotAsked" ? placeholderEmptyState : JsxRuntime.jsx(Placeholder.make, {
        status: "Loading",
        compact: compactPlaceholder
      });
  } else if (data.TAG === "Reloading") {
    if (hideReloadingPlaceholder) {
      exit = data._0.TAG === "Ok" ? 2 : 1;
    } else {
      footerComponent = JsxRuntime.jsx(Placeholder.make, {
        status: "Loading",
        compact: compactPlaceholder
      });
    }
  } else {
    let match = data._0;
    if (match.TAG === "Ok") {
      if (match._0.length !== 0) {
        exit = 2;
      } else {
        footerComponent = placeholderEmptyState;
      }
    } else {
      exit = 1;
    }
  }
  switch (exit) {
    case 1 :
      footerComponent = JsxRuntime.jsx(Placeholder.make, {
        status: "Error",
        compact: compactPlaceholder
      });
      break;
    case 2 :
      footerComponent = Stdlib_Option.isSome(onLoadMoreProp) && AsyncData.isReloading(data) ? JsxRuntime.jsx(TableView$LoadMoreSpinner, {}) : undefined;
      break;
  }
  let rows;
  if (typeof data !== "object") {
    rows = data === "NotAsked" ? [] : [];
  } else if (data.TAG === "Reloading") {
    let rows$1 = data._0;
    rows = rows$1.TAG === "Ok" ? rows$1._0 : [];
  } else {
    let rows$2 = data._0;
    rows = rows$2.TAG === "Ok" ? rows$2._0 : [];
  }
  let loadingBarStatus = Stdlib_Option.map(loadingBarEstimatedDuration, param => PredictiveLoadingBar.statusFromAsyncResult(data));
  let tableComponent = JsxRuntime.jsx(Table.make, {
    columns: props.columns,
    rows: rows,
    keyExtractor: props.keyExtractor,
    disabledRowsKeys: props.disabledRowsKeys,
    erroredRowsMap: props.erroredRowsMap,
    selectionEnabled: props.selectionEnabled,
    selectAllEnabled: props.selectAllEnabled,
    initialAllSelected: props.initialAllSelected,
    sortDescriptor: props.sortDescriptor,
    maxWidth: props.maxWidth,
    minHeight: props.minHeight,
    maxHeight: props.maxHeight,
    compactRows: props.compactRows,
    footerComponent: footerComponent,
    onLoadMore: onLoadMore,
    onSelectChange: props.onSelectChange,
    onSortChange: props.onSortChange,
    bodyRef: props.bodyRef,
    loadingBarStatus: loadingBarStatus,
    loadingBarEstimatedDuration: loadingBarEstimatedDuration
  });
  return JsxRuntime.jsxs(make, {
    children: [
      searchBar !== undefined ? searchBar : (
          onSearchQueryChange !== undefined ? JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(SearchBar.make, {
                placeholder: searchPlaceholder,
                value: props.searchQuery,
                onChange: onSearchQueryChange
              }),
              spaceX: "large",
              spaceBottom: "xmedium"
            }) : null
        ),
      filters.length !== 0 ? JsxRuntime.jsx(TableView$TableFilterBar, {
          filters: filters
        }) : null,
      onSuccessDrop !== undefined && onErrorDrop !== undefined ? JsxRuntime.jsx(DropZone.make, {
          children: tableComponent,
          types: props.typesDrop,
          onSuccess: onSuccessDrop,
          onError: onErrorDrop
        }) : tableComponent
    ],
    displayed: !hideCard
  });
}

let make$1 = TableView;

export {
  make$1 as make,
}
/* make Not a pure module */
